// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiV3Time (params?: {}): Promise<Dict>;
    publicGetApiV3Coins (params?: {}): Promise<List>;
    publicGetApiV3ExchangeInfo (params?: {}): Promise<Dict>;
    publicGetApiV3Ping (params?: {}): Promise<Dict>;
    publicGetApiV3ApiTradingSymbols (params?: {}): Promise<List>;
    publicGetApiV3MarketTickerPrice (params?: {}): Promise<List>;
    publicGetApiV3MarketTicker24hr (params?: {}): Promise<Dict | List>;
    publicGetApiV3MarketTrades (params?: {}): Promise<List>;
    publicGetApiV3MarketKlines (params?: {}): Promise<List>;
    publicGetApiV3MarketDepth (params?: {}): Promise<Dict>;
    publicGetApiV3MarketTickerBookTicker (params?: {}): Promise<List>;
    privateGetApiV3Account (params?: {}): Promise<Dict>;
    privateGetApiV3AccountTransferRecords (params?: {}): Promise<List>;
    privateGetApiV3Order (params?: {}): Promise<Dict>;
    privateGetApiV3OpenOrders (params?: {}): Promise<List>;
    privateGetApiV3AllOrders (params?: {}): Promise<List>;
    privateGetApiV3MyTrades (params?: {}): Promise<List>;
    privateGetApiV3RebateAffiliateGetAffiliateUIDs (params?: {}): Promise<Dict>;
    privateGetApiV3RebateAffiliateGetChannelUserTradeAndAsset (params?: {}): Promise<Dict>;
    privateGetApiV3RebateAffiliateGetAffiliateCommission (params?: {}): Promise<Dict>;
    privateGetApiV3RebateAffiliateGetInternalWithdrawalStatus (params?: {}): Promise<Dict>;
    privateGetApiV3RebateAffiliateQuerySubChannelTransactions (params?: {}): Promise<Dict>;
    privateGetApiV3AgencyVerifyReferrals (params?: {}): Promise<List>;
    privateGetApiV3AgencyGetAssert (params?: {}): Promise<Dict>;
    privateGetApiV3AgencyGetDealData (params?: {}): Promise<Dict>;
    privateGetApiV3ApiReferralCheckUserEligibility (params?: {}): Promise<Dict>;
    privateGetApiV3ApiReferralRebateRecentRecord (params?: {}): Promise<Dict>;
    privateGetApiV3ApiReferralRebateRatio (params?: {}): Promise<Dict>;
    privateGetApiV3ContentArticlesDetail (params?: {}): Promise<Dict>;
    privateGetApiV3ContentArticlesList (params?: {}): Promise<Dict>;
    privateGetApiV3ContentArticlesListByCoin (params?: {}): Promise<Dict>;
    privateGetApiV3ContentBannersLatest (params?: {}): Promise<Dict>;
    privatePostApiV3AccountBills (params?: {}): Promise<List>;
    privatePostApiV3AccountFundingBills (params?: {}): Promise<Dict>;
    privatePostApiV3Order (params?: {}): Promise<Dict>;
    privatePostApiV3OrderBatch (params?: {}): Promise<Dict>;
    privatePostApiV3RebateAffiliateInternalWithdrawal (params?: {}): Promise<string>;
    privatePostApiV3TaxIncome (params?: {}): Promise<List>;
    privateDeleteApiV3Order (params?: {}): Promise<Dict>;
    privateDeleteApiV3OpenOrders (params?: {}): Promise<List>;
    privateDeleteApiV3OrderBatch (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketTime (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketExchangeInfo (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketDepth (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketTicker24hr (params?: {}): Promise<List>;
    contractGetCapiV3MarketTickerBookTicker (params?: {}): Promise<List>;
    contractGetCapiV3MarketTrades (params?: {}): Promise<List>;
    contractGetCapiV3MarketKlines (params?: {}): Promise<List>;
    contractGetCapiV3MarketIndexPriceKlines (params?: {}): Promise<List>;
    contractGetCapiV3MarketMarkPriceKlines (params?: {}): Promise<List>;
    contractGetCapiV3MarketHistoryKlines (params?: {}): Promise<List>;
    contractGetCapiV3MarketSymbolPrice (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketOpenInterest (params?: {}): Promise<Dict>;
    contractGetCapiV3MarketPremiumIndex (params?: {}): Promise<List>;
    contractGetCapiV3MarketFundingRate (params?: {}): Promise<List>;
    contractGetCapiV3MarketApiTradingSymbols (params?: {}): Promise<List>;
    contractPrivateGetCapiV3AccountBalance (params?: {}): Promise<List>;
    contractPrivateGetCapiV3AccountCommissionRate (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3AccountAccountConfig (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3AccountSymbolConfig (params?: {}): Promise<List>;
    contractPrivateGetCapiV3AccountPositionAllPosition (params?: {}): Promise<List>;
    contractPrivateGetCapiV3AccountPositionSinglePosition (params?: {}): Promise<List>;
    contractPrivateGetCapiV3Order (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3OpenOrders (params?: {}): Promise<List>;
    contractPrivateGetCapiV3OrderHistory (params?: {}): Promise<List>;
    contractPrivateGetCapiV3UserTrades (params?: {}): Promise<List>;
    contractPrivateGetCapiV3OpenAlgoOrders (params?: {}): Promise<List>;
    contractPrivateGetCapiV3AllAlgoOrders (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3SimBalance (params?: {}): Promise<List>;
    contractPrivateGetCapiV3SimPositionAllPosition (params?: {}): Promise<List>;
    contractPrivateGetCapiV3SimOrderHistory (params?: {}): Promise<List>;
    contractPrivateGetCapiV3CopyFollowerHistoryOrders (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3CopyFollowerMyTraders (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3CopyFollowerOpenOrders (params?: {}): Promise<List>;
    contractPrivateGetCapiV3CopyFollowerSettings (params?: {}): Promise<List>;
    contractPrivateGetCapiV3CopyTraderHistoryOrders (params?: {}): Promise<Dict>;
    contractPrivateGetCapiV3CopyTraderOpenOrders (params?: {}): Promise<List>;
    contractPrivateGetCapiV3CopyTraderPairs (params?: {}): Promise<List>;
    contractPrivateGetCapiV3TrailingOpenOrders (params?: {}): Promise<List>;
    contractPrivateGetCapiV3TrailingHistoryOrders (params?: {}): Promise<List>;
    contractPrivatePostCapiV3AccountIncome (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3AccountMarginType (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3AccountLeverage (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3AccountPositionMargin (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3AccountModifyAutoAppendMargin (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3Order (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3BatchOrders (params?: {}): Promise<List>;
    contractPrivatePostCapiV3ClosePositions (params?: {}): Promise<List>;
    contractPrivatePostCapiV3AlgoOrder (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3PlaceTpSlOrder (params?: {}): Promise<List>;
    contractPrivatePostCapiV3ModifyTpSlOrder (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3SimOrder (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3CopyFollowerClosePos (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3CopyFollowerSettings (params?: {}): Promise<Dict>;
    contractPrivatePostCapiV3CopyFollowerStopCopy (params?: {}): Promise<Dict>;
    contractPrivateDeleteCapiV3Order (params?: {}): Promise<Dict>;
    contractPrivateDeleteCapiV3BatchOrders (params?: {}): Promise<Dict>;
    contractPrivateDeleteCapiV3AllOpenOrders (params?: {}): Promise<List>;
    contractPrivateDeleteCapiV3AlgoOrder (params?: {}): Promise<Dict>;
    contractPrivateDeleteCapiV3AlgoOpenOrders (params?: {}): Promise<List>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
